import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { STORAGE_ENABLED } from '@/config/env';
import { objectUrl } from '@/lib/firebase';


const RETRY_DELAYS_MS = [5_000, 10_000, 20_000, 30_000];

export function useObjectUrlQuery(objectName: string | null): UseQueryResult<string | null> {
  return useQuery({
    queryKey: ['storage-object', objectName],
    enabled: Boolean(objectName),
    staleTime: Infinity,
    retry: RETRY_DELAYS_MS.length,
    retryDelay: (failureCount) => RETRY_DELAYS_MS[failureCount],
    queryFn: () => (STORAGE_ENABLED ? objectUrl(objectName as string) : Promise.resolve(null)),
  });
}

/** The URL an `<img>` can load; null while resolving and when there is none. */
export function useObjectUrl(objectName: string | null): string | null {
  return useObjectUrlQuery(objectName).data ?? null;
}
